import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AUTH_PAGE_STYLES = `
html {
  overflow-y: scroll;
  scrollbar-gutter: stable;
}

.auth-marketing-page {
  min-height: 100vh;
  background: #0a1628;
  color: #e8f0f9;
  font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;
  padding-top: 74px;
}

.auth-top-nav {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 20;
  height: 74px;
  background: #0a1628;
  border-bottom: 1px solid rgba(0, 212, 255, 0.13);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.18);
}

.auth-nav-inner {
  width: min(100%, 1180px);
  height: 100%;
  margin: 0 auto;
  padding: 0 1.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
}

.auth-brand {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  color: #fff;
  font-size: 1.22rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0;
  text-decoration: none;
}

.auth-brand:hover,
.auth-nav-link:hover {
  text-decoration: none;
}

.auth-brand-mark {
  width: 25px;
  height: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 25px;
  line-height: 0;
}

.auth-brand-mark svg {
  width: 25px;
  height: 25px;
  display: block;
}

.auth-brand-dashboard {
  color: #f4f8ff;
}

.auth-brand-portfolio {
  color: #00d4ff;
}

.auth-nav-right {
  display: flex;
  align-items: center;
  gap: 1.8rem;
}

.auth-nav-menu {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.auth-nav-link {
  color: #dfefff;
  font-size: 0.86rem;
  font-weight: 700;
  text-decoration: none;
  transition: color 0.2s ease;
}

.auth-nav-link:hover {
  color: #00d4ff;
}

.auth-nav-signin {
  color: #00d4ff;
}

.auth-nav-cta {
  min-height: 40px;
  padding: 0.72rem 1.15rem;
  border-radius: 7px;
  background: #00d4ff;
  color: #061321;
  font-size: 0.85rem;
  font-weight: 800;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.auth-nav-cta:hover {
  background: #16ddff;
  box-shadow: 0 12px 30px rgba(0, 212, 255, 0.18);
  transform: translateY(-1px);
  text-decoration: none;
}

.auth-center-stage {
  min-height: calc(100vh - 74px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3.5rem 1.25rem;
}

.auth-modern-card {
  width: min(100%, 390px);
  background: rgba(19, 34, 64, 0.82);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 12px;
  box-shadow: 0 22px 60px rgba(0, 0, 0, 0.28);
  padding: 2.15rem 2rem 1.75rem;
}

.auth-modern-header {
  text-align: center;
  margin-bottom: 1.8rem;
}

.auth-modern-header h1 {
  color: #00d4ff;
  font-size: 1.35rem;
  font-weight: 800;
  margin: 0 0 0.45rem;
}

.auth-modern-header p {
  color: #8aa6bf;
  font-size: 0.84rem;
  margin: 0;
}

.auth-modern-form {
  display: flex;
  flex-direction: column;
  gap: 1.05rem;
}

.auth-modern-field {
  display: flex;
  flex-direction: column;
  gap: 0.42rem;
}

.auth-modern-field label {
  color: #8aa6bf;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.auth-input-wrap {
  position: relative;
}

.auth-modern-input {
  width: 100%;
  height: 43px;
  padding: 0 2.7rem 0 0.85rem;
  background: #0f223a;
  border: 1px solid rgba(0, 212, 255, 0.18);
  border-radius: 7px;
  color: #e8f0f9;
  font-size: 0.86rem;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.auth-modern-input::placeholder {
  color: #6f89a2;
}

.auth-modern-input:focus {
  background: #102743;
  border-color: #00d4ff;
  box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.08);
}

.auth-input-icon {
  position: absolute;
  top: 50%;
  right: 0.55rem;
  width: 24px;
  height: 24px;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #7a99b8;
  background: rgba(232, 240, 249, 0.08);
  border: 1px solid rgba(232, 240, 249, 0.12);
  border-radius: 5px;
  pointer-events: none;
}

.auth-input-icon svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.auth-modern-submit {
  width: 100%;
  min-height: 43px;
  margin-top: 0.4rem;
  border-radius: 7px;
  background: #00d4ff;
  color: #061321;
  font-size: 0.9rem;
  font-weight: 800;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.auth-modern-submit:hover:not(:disabled) {
  background: #16ddff;
  box-shadow: 0 12px 30px rgba(0, 212, 255, 0.18);
  transform: translateY(-1px);
}

.auth-modern-submit:disabled {
  cursor: not-allowed;
  opacity: 0.72;
}

.auth-modern-error {
  padding: 0.75rem;
  background: rgba(255, 61, 90, 0.1);
  border: 1px solid rgba(255, 61, 90, 0.7);
  border-radius: 0.5rem;
  color: #ff7d90;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

.auth-modern-footer {
  margin-top: 1.35rem;
  text-align: center;
  color: #8aa6bf;
  font-size: 0.83rem;
}

.auth-modern-footer p {
  margin: 0.55rem 0 0;
}

.auth-modern-footer a {
  color: #00d4ff;
  font-weight: 700;
  text-decoration: none;
}

.auth-modern-footer a:hover {
  text-decoration: underline;
}

@media (max-width: 760px) {
  .auth-nav-menu {
    display: none;
  }

  .auth-nav-right {
    gap: 0.9rem;
  }

  .auth-modern-card {
    padding: 1.75rem 1.4rem 1.45rem;
  }
}
`;

function BrandMark() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true">
      <rect x="3" y="15" width="6" height="11" rx="2" fill="#00d4ff" opacity="0.75" />
      <rect x="13" y="9" width="6" height="17" rx="2" fill="#00d4ff" />
      <rect x="23" y="5" width="6" height="21" rx="2" fill="#0099cc" />
      <path d="M5 12 14 7l5 4 8-8" fill="none" stroke="#7ae7ee" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function AuthNav() {
  return (
    <nav className="auth-top-nav">
      <div className="auth-nav-inner">
        <Link className="auth-brand" to="/">
          <span className="auth-brand-mark"><BrandMark /></span>
          <span><span className="auth-brand-portfolio">North</span><span className="auth-brand-dashboard">folio</span></span>
        </Link>

        <div className="auth-nav-right">
          <div className="auth-nav-menu">
            <Link className="auth-nav-link" to="/#features">Features</Link>
            <Link className="auth-nav-link" to="/#pricing">Pricing</Link>
            <Link className="auth-nav-link" to="/#faq">FAQ</Link>
          </div>
          <Link className="auth-nav-link auth-nav-signin" to="/login">Sign in</Link>
          <Link className="auth-nav-cta" to="/register">Get Started</Link>
        </div>
      </div>
    </nav>
  );
}

function InputIcon({ type }) {
  if (type === 'mail') {
    return (
      <span className="auth-input-icon">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 6h16v12H4z" />
          <path d="m4 7 8 6 8-6" />
        </svg>
      </span>
    );
  }

  if (type === 'lock') {
    return (
      <span className="auth-input-icon">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="5" y="11" width="14" height="10" rx="2" />
          <path d="M8 11V8a4 4 0 0 1 8 0v3" />
        </svg>
      </span>
    );
  }

  return (
    <span className="auth-input-icon">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20 21a8 8 0 0 0-16 0" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    </span>
  );
}

function RegisterPage() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!username || !email || !password) {
      setError('All fields are required');
      return;
    }
    
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    
    setIsSubmitting(true);
    const success = await register(username, email, password);
    setIsSubmitting(false);
    
    if (success) {
      navigate('/login');
    }
  };

  return (
    <div className="auth-marketing-page">
      <style>{AUTH_PAGE_STYLES}</style>
      <AuthNav />

      <main className="auth-center-stage">
        <div className="auth-modern-card">
          <div className="auth-modern-header">
            <h1>Create Account</h1>
            <p>Register to start tracking your portfolio</p>
          </div>
          
          {error && (
            <div className="auth-modern-error">
              {error}
            </div>
          )}
          
          <form className="auth-modern-form" onSubmit={handleSubmit}>
            <div className="auth-modern-field">
              <label htmlFor="username">Username</label>
              <div className="auth-input-wrap">
                <input
                  id="username"
                  className="auth-modern-input"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Choose a username"
                  required
                />
                <InputIcon />
              </div>
            </div>
            
            <div className="auth-modern-field">
              <label htmlFor="email">Email</label>
              <div className="auth-input-wrap">
                <input
                  id="email"
                  className="auth-modern-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                />
                <InputIcon type="mail" />
              </div>
            </div>
            
            <div className="auth-modern-field">
              <label htmlFor="password">Password</label>
              <div className="auth-input-wrap">
                <input
                  id="password"
                  className="auth-modern-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Create a password"
                  required
                />
                <InputIcon type="lock" />
              </div>
            </div>
            
            <div className="auth-modern-field">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <div className="auth-input-wrap">
                <input
                  id="confirmPassword"
                  className="auth-modern-input"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm your password"
                  required
                />
                <InputIcon type="lock" />
              </div>
            </div>
            
            <button
              type="submit"
              className="auth-modern-submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Creating account...' : 'Create Account'}
            </button>
          </form>
          
          <div className="auth-modern-footer">
            <p>
              Already have an account?{' '}
              <Link to="/login">Sign in</Link>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default RegisterPage;
